export enum GridView {
  LIST = 'LIST',
  TILE = 'TILE',
  TABLE = 'TABLE',
}

export namespace GridView {
  export function getAll(): GridView[] {
    return [GridView.TILE, GridView.LIST];
  }

  export function getAllIncludingTable(): GridView[] {
    return [GridView.TILE, GridView.LIST, GridView.TABLE];
  }

  export function getDisplayName(view?: GridView): string {
    switch (view) {
      case GridView.LIST:
        return 'APP.GRID_VIEW.CARD';
      case GridView.TILE:
        return 'APP.GRID_VIEW.TILE';
      case GridView.TABLE:
        return 'APP.GRID_VIEW.TABLE';
      default:
        return '';
    }
  }

  export function getIcon(view?: GridView): string {
    switch (view) {
      case GridView.LIST:
        return 'fa-pager';
      case GridView.TILE:
        return 'fa-grid-2';
      case GridView.TABLE:
        return 'fa-list';
      default:
        return '';
    }
  }

  export function getIconLarge(view?: GridView): string {
    switch (view) {
      case GridView.LIST:
        return 'fa-lg fa-regular fa-pager';
      case GridView.TILE:
        return 'fa-lg fa-regular fa-grid-2';
      case GridView.TABLE:
        return 'fa-lg fa-regular fa-list';
      default:
        return '';
    }
  }
}
